module.exports = __webpack_public_path__ + "img/signin.fa364bb3.jpg";